"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Плагин для преобразования запросов за урлом бандла расширения в урл из манифеста хоста
 */
const runtimePlugin = () => {
    return {
        name: '@vk-tech-solar/loader-module-federation',
        beforeRequest(args) {
            const globalObject = typeof window !== 'undefined' ? window : global;
            const solar = globalObject.solar;
            if (!solar) {
                return args;
            }
            args.options.remotes.forEach((remote) => {
                // @ts-ignore
                const name = (remote.entry.match(/(.*?)\[(.+?)](.*)/) ?? [])[2];
                const targetName = name ?? remote.alias;
                // @ts-ignore
                remote.entry =
                    (solar.getExtensionLoaderInfo
                        ? solar.getExtensionLoaderInfo(targetName, '@vk-tech-solar/loader-module-federation')
                        : solar.getExtensionLoaderInfoCustom?.(targetName, '@vk-tech-solar/loader-module-federation'))?.options?.url ??
                        // @ts-ignore
                        remote.entry;
            });
            return args;
        },
    };
};
exports.default = runtimePlugin;
